const missingValueDefault = (field, lang) => {
    const code = field.getAttribute("data-code");

    const messages = {
        ro: {
            product_locality_search:
                "Te rugăm să selectezi localitatea în care dorești livrarea.",
            product_country_search:
                "Te rugăm să selectezi țara în care dorești livrarea",
            product_date_and_time:
                "Te rugăm să alegi data la care dorești livrarea. ",
            default: "Te rugăm să completezi acest câmp.",
        },
        en: {
            product_locality_search: "Please select the delivery location",
            product_country_search: "Please select the delivery country",
            product_date_and_time: "Please choose the delivery date",
            default: "Please fill out this field.",
        },
    };

    return messages[lang][code] || messages[lang]["default"];
};

const messages = {
    en: {
        alphanumeric: "Only alphanumeric characters are allowed.",
        missingValue: {
            checkbox: "This field is required.",
            radio: "Please select a value.",
            select: "Please select a value.",
            "select-multiple": "Please select at least one value.",
            default: (field) => missingValueDefault(field, "en"),
        },
        patternMismatch: {
            email: "Please enter a valid email address.",
            url: "Please enter a URL.",
            number: "Please enter a number",
            color: "Please match the following format: #rrggbb",
            date: "Please use the YYYY-MM-DD format",
            time: "Please use the 24-hour time format. Ex. 23:00",
            month: "Please use the YYYY-MM format",
            password: "The password must contain at least 6 characters.",
            default: "Please match the requested format.",
        },
        outOfRange: {
            over: "Please select a value that is no more than {max}.",
            under: "Please select a value that is no less than {min}.",
        },
        wrongLength: {
            over: "The text must not contain more than {maxLength} characters.",
            under: "The text must contain at least {maxLength} characters",
        },
        fallback: "There was an error with this field.",
    },
    ro: {
        alphanumeric: "Sunt permise doar caractere alfa-numerice",
        missingValue: {
            checkbox: "Acest câmp este obligatoriu.",
            radio: "Te rugăm să selectezi o valoare.",
            select: "Te rugăm să selectezi o valoare.",
            "select-multiple": "Te rugăm să selectezi cel puțin o valoare.",
            default: (field) => missingValueDefault(field, "ro"),
        },
        patternMismatch: {
            email: "Te rugăm să introduci o adresă de email validă.",
            url: "Te rugăm să introduci o adresă URL",
            number: "Te rugăm să introduci un număr.",
            color: "Te rugăm să respecți formatul următor: #rrggbb",
            date: "Te rugăm să utilizezi formatul YYYY-MM-DD",
            time: "Te rugăm să utilizezi formatul de 24 de ore. Ex. 23:00",
            month: "Te rugăm să utilizezi formatul YYYY-MM",
            password: "Parola trebuie să conțină minimum 6 caractere.",
            default: "Te rugăm să respecți formatul cerut.",
        },
        outOfRange: {
            over: "Te rugăm să selectezi o valoare care să nu fie mai mare de {max}.",
            under: "Te rugăm să selectezi o valoare care să nu fie mai mică de {min}.",
        },
        wrongLength: {
            over: "Textul trebuie să conțină minimum {maxLength} caractere.",
            under: "Textul trebuie să conțină minimum {minLength} caractere.",
        },
        fallback: "A apărut o eroare cu acest câmp.",
    },
};

export default messages;
